var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"500px","width":"100%","margin":"80px"},attrs:{"id":"main"}}),_c('div',{staticStyle:{"height":"500px","width":"100%","margin":"80px"},attrs:{"id":"main1"}}),_c('div',{staticStyle:{"height":"500px","width":"100%","margin":"80px"},attrs:{"id":"main2"}})])
}]

export { render, staticRenderFns }